<template>
  <div class="content-container">
    <el-breadcrumb separator="/" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/dashboard/customers/' + customerID }"
        >客户信息</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="orderMode">
        {{ orderID > 0 ? '编辑报价单' : '新建报价单' }}
      </el-breadcrumb-item>
      <el-breadcrumb-item v-else>
        {{ quotationID > 0 ? '编辑报价单' : '新建报价单' }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <h6 class="content-header">
      {{ quotationID > 0 ? '编辑报价单' : '新建报价单' }}
    </h6>-->
    <div class="panel mt-20">
      <div class="flex-row-between">
        <div class="flex">
          <div class="number-info" style="min-width: 330px; margin-right: 20px">
            <span class="title">客户名称</span>
            <div class="flex-row-base">
              <div style="line-height: 32px; font-size: 14px">
                {{ quotation.customer.name }}
              </div>
            </div>
          </div>
          <div v-if="quotation.id" class="number-info">
            <span class="title">报价编号</span>
            <div class="flex-row-base content">
              <!-- <span>{{ quotation.number }}</span> -->
              <el-input
                size="small"
                v-model="quotation.number"
                style="width: 330px"
              ></el-input>
              <el-select
                v-if="!orderMode"
                size="small"
                v-model="selectedVersion"
                placeholder="请选择"
                style="width: 140px; margin-left: 10px"
              >
                <el-option
                  v-for="(version, i) in versions"
                  :key="version.title"
                  :label="version.title"
                  :value="i"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div>
          <el-checkbox
            style="color: #888; margin-right: 10px"
            v-if="quotation.id > 0 && !orderMode"
            v-model="save_as_new_version"
            :disabled="selectedVersion > 0"
            >保存为新版本</el-checkbox
          >
          <el-button
            icon="el-icon-check"
            size="medium"
            type="primary"
            @click="postQuotation"
            :loading="submiting"
            >保存
          </el-button>
          <el-button
            icon="el-icon-view"
            size="medium"
            type="primary"
            plain
            @click="previewQuotation()"
            >预览</el-button
          >
        </div>
      </div>
    </div>

    <div class="panel mt-20">
      <el-form
        ref="orderInfoForm"
        label-width="70px"
        :model="quotation.order_info"
        :rules="orderInfoRules"
        label-position="top"
        class="order-form"
        size="small"
      >
        <el-form-item label="报价类型" prop="type">
          <el-select v-model="quotation.order_info.type" style="width: 100%">
            <el-option key="1" label="备件" :value="1"></el-option>
            <el-option key="2" label="服务" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目" prop="project_name">
          <el-input
            v-model="quotation.order_info.project_name"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="customer_contact_id">
          <el-select
            size="small"
            v-model="quotation.order_info.customer_contact_id"
            allow-creates
            filterable
            placeholder="请选择报价联系人"
          >
            <el-option
              v-for="item in contacts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <span style="float: left"
                >{{ item.name }}({{ item.mobile }})</span
              >
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.duty
              }}</span>
            </el-option>
          </el-select>
          <el-button
            style="margin-left: 10px"
            type="primary"
            size="small"
            plain
            icon="el-icon-plus"
            @click="startCustomerContactFormer"
            >新联系人</el-button
          >
        </el-form-item>
        <el-form-item
          label="最终用户"
          prop="install_customer_id"
          :rules="[{ validator: checkInstallCustomerId, trigger: 'change' }]"
        >
          <CustomerSelector
            v-model="quotation.order_info.install_customer_id"
            :category="6"
          ></CustomerSelector>
        </el-form-item>
        <el-form-item label="机会种类" prop="business_opportunity_type">
          <BusinessOpportunitySelector
            v-model="quotation.order_info.business_opportunity_type"
          ></BusinessOpportunitySelector>
        </el-form-item>
        <el-form-item label="业务机会编号" prop="business_chance_number">
          <ServiceQuestSelect
            style="width: 100%"
            v-if="customerID"
            :customerid="customerID"
            v-model="quotation.order_info.business_chance_number"
          ></ServiceQuestSelect>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="panel mt-20">
      <div class="header">
        <h2>客户信息</h2>
      </div>
      <ul>
        <li class="sub-info">
          <div class="sub-info-label">客户名称</div>
          <div class="sub-info-value">{{ quotation.customer.name }}</div>
        </li>
        <li class="sub-info">
          <div class="sub-info-label">客户地址</div>
          <div class="sub-info-value">
            {{ CustomerAddress(quotation.customer) }}
          </div>
        </li>
        <li class="sub-info">
          <div class="sub-info-label">项目</div>
          <div class="sub-info-value">
            <el-input
              v-model="quotation.order_info.project_name"
              size="small"
            ></el-input>
          </div>
        </li>
        <li class="sub-info">
          <div class="sub-info-label">联系人</div>
          <div class="sub-info-value">
            <el-select
              size="small"
              v-model="quotation.order_info.customer_contact_id"
              allow-creates
              filterable
              placeholder="请选择报价联系人"
            >
              <el-option
                v-for="item in contacts"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.duty
                }}</span>
              </el-option>
            </el-select>
            <el-button
              style="margin-left: 10px"
              type="primary"
              size="small"
              plain
              icon="el-icon-plus"
              @click="startCustomerContactFormer"
              >新联系人</el-button
            >
          </div>
        </li>
      </ul>
    </div> -->
    <div class="panel mt-20" v-if="quotation.order_info.products.length > 0">
      <div class="header flex-row-between">
        <h2>产品清单</h2>
      </div>
      <div class="mt-10">
        <el-button
          @click="productSelectorVisible = true"
          size="small"
          type="primary"
          icon="el-icon-plus"
          >选择产品
        </el-button>
      </div>
      <template v-if="quotation.order_info.products.length > 0">
        <el-table
          :data="quotation.order_info.products"
          style="width: 100%"
          empty-text
          row-class-name="custom-device-row"
          ref="itemTable"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="name" label="件号">
            <template slot-scope="scope">
              <div>
                {{ scope.row.item.part_number }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="描述">
            <template slot-scope="scope">
              <span>{{ scope.row.item.description }}</span>
            </template>
          </el-table-column>
          <el-table-column label="价格(￥)" width="200">
            <template slot-scope="scope">
              <el-input
                size="mini"
                class="font-14"
                v-model="scope.row.price"
                type="number"
                @change="recalculateItemFee(scope.$index)"
              ></el-input>
              <div class="price-info">
                <span>原价：{{ scope.row.item.price }}</span>
                <span>
                  {{
                    priceIncreasePercent(scope.row.item.price, scope.row.price)
                  }}%
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="count" label="数量" width="120">
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                v-model="scope.row.count"
                :min="0"
                :step="1"
                @change="recalculateItemFee()"
              >
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <el-button
                class="text-danger"
                type="text"
                size="mini"
                plain
                @click="removeProducts(scope.$index)"
                >移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="clearfix mt-10">
          <div class="ml-15" style="float: left">
            <el-checkbox v-model="selectedAll" @change="handleSelectedAllChange"
              >全选</el-checkbox
            >
            <el-button
              type="danger"
              plain
              size="mini"
              class="ml-5"
              @click="batchRemove"
              >批量移除</el-button
            >
          </div>

          <div style="margin-right: 178px; float: right">
            <label class="text-info-12">整体调价</label>
            <el-input-number
              style="width: 128px"
              :step="1"
              size="mini"
              v-model="productIncrease"
              :step-strictly="true"
            >
            </el-input-number
            >%
          </div>
        </div>
      </template>
    </div>

    <div class="panel mt-20" v-else>
      <div class="header">
        <h2>产品清单</h2>
        <el-button
          @click="openDeviceSelector"
          size="small"
          type="primary"
          icon="el-icon-plus"
          class="mt-10"
          >添加设备</el-button
        >
      </div>
      <template v-if="quotation.order_info.devices.length > 0">
        <ul class="devices">
          <li
            v-for="(device, index) in quotation.order_info.devices"
            :key="index"
          >
            <div class="device-header">
              <div class="flex flex-align-center">
                <div class="font-12">设备{{ index + 1 }}：</div>
                <CustomerDeviceSelect
                  style="width: 50%"
                  :customerID="customerID"
                  :val="device.customer_device_id"
                  @change="device.customer_device_id = $event"
                >
                </CustomerDeviceSelect>
                <el-button
                  size="mini"
                  @click="openItemSelector(device, index)"
                  type="primary"
                  class="ml-10"
                  plain
                  >选择产品</el-button
                >
                <el-popconfirm
                  title="确认删除该设备吗？"
                  @confirm="removeDevice(index)"
                >
                  <el-button
                    size="mini"
                    type="danger"
                    class="ml-10"
                    slot="reference"
                    plain
                    >删除设备</el-button
                  >
                </el-popconfirm>
                <el-link
                  class="ml-10 font-12"
                  type="primary"
                  :underline="false"
                  v-if="device.customer_device_id"
                  @click="openDeviceWiki(device)"
                  >技术资料</el-link
                >
              </div>
            </div>
            <el-table sizi="mini" :data="device.items" style="width: 100%">
              <!-- <el-table-column width="55">
                <template slot-scope="scope">
                  <el-checkbox
                    @change="toggelChecked(scope.row)"
                    :checked="scope.row.checked"
                    :label="scope.row.part_number"
                  ></el-checkbox>
                </template>
              </el-table-column> -->

              <el-table-column
                prop="item.part_number"
                label="件号"
              ></el-table-column>
              <el-table-column
                prop="item.description"
                label="描述"
              ></el-table-column>
              <el-table-column label="价格(￥)" width="200">
                <template slot-scope="scope">
                  <el-input
                    size="mini"
                    class="font-14"
                    v-model="scope.row.price"
                    @change="recalculateItemFee()"
                  ></el-input>
                  <div class="price-info">
                    <span>原价：{{ scope.row.item.price }}</span>
                    <span>
                      {{
                        priceIncreasePercent(
                          scope.row.item.price,
                          scope.row.price
                        )
                      }}%
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量" width="120">
                <template slot-scope="scope">
                  <el-input-number
                    size="mini"
                    v-model="scope.row.count"
                    :step="1"
                    :min="0"
                    @change="recalculateItemFee()"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="60" align="center">
                <template slot-scope="scope">
                  <el-button
                    class="text-danger"
                    type="text"
                    size="mini"
                    plain
                    @click="removeDeviceItem(index, scope.$index)"
                    >移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </li>
        </ul>
        <div class="clearfix mt-10">
          <div style="margin-right: 178px; float: right">
            <label class="text-info-12">整体调价</label>
            <el-input-number
              style="width: 128px"
              :step="1"
              size="mini"
              v-model="deviceIncrease"
              :step-strictly="true"
            ></el-input-number
            >%
          </div>
        </div>
      </template>
    </div>

    <el-row :gutter="14" class="flex-row">
      <el-col :span="12">
        <!-- <div class="panel mt-20">
          <div class="header flex-row-between">
            <h2>保养方案</h2>
            <el-button
              @click="openDeviceSelector"
              size="small"
              type="primary"
              icon="el-icon-plus"
            >添加保养设备</el-button>
          </div>
          <template v-if="quotation.order_info.devices.length > 0">
            <ul class="devices">
              <li v-for="(device, index) in quotation.order_info.devices" :key="index">
                <div class="device-header">
                  <div class="flex-row-between">
                    <div class="font-12">设备{{ index + 1 }}：{{ device.item_category.name }}</div>
                    <div class="device-select">
                      <label for>工况</label>
                      <el-select
                        style="width:100px"
                        v-model="device.working_condition"
                        placeholder="请选择"
                        size="mini"
                        @change="reloadDeviceScheme(device, index)"
                      >
                        <el-option
                          v-for="item in conditions"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                      <label for>运行时长</label>
                      <el-select
                        style="width:100px"
                        v-model="device.running_time"
                        placeholder="请选择"
                        size="mini"
                        @change="reloadDeviceScheme(device, index)"
                      >
                        <el-option v-for="item in runtimes" :key="item" :label="item" :value="item"></el-option>
                      </el-select>
                      <span>H</span>
                    </div>
                  </div>
                </div>
                <div class="flex-row-between">
                  <el-button
                    size="small"
                    @click="openItemSelector(device, index)"
                    type="primary"
                    plain
                    icon="el-icon-plus"
                  >补充零件</el-button>

                  <el-button
                    class="del-device"
                    size="small"
                    @click="removeDevice(index)"
                    type="danger"
                    plain
                    icon="el-icon-delete"
                  ></el-button>
                </div>

                <el-table
                  :data="device.items"
                  style="width: 100%"
                  empty-text="当前状态设备无须保养，或未录入此状态保养计划，请联系管理员"
                  row-class-name="custom-device-row"
                  :key="Math.random()"
                >
                  <el-table-column width="34">
                    <template slot-scope="scope">
                      <el-checkbox
                        @change="toggelChecked(scope.row)"
                        :checked="scope.row.checked"
                        :label="scope.row.part_number"
                      ></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="item.name" label="滤芯包&阀件&维修包"></el-table-column>
                  <el-table-column prop="item.part_number" label="件号" width="120"></el-table-column>
                  <el-table-column label="价格(￥)" width="160">
                    <template slot-scope="scope">
                      <el-input
                        size="mini"
                        class="font-14"
                        v-model="scope.row.price"
                        @change="recalculateItemFee()"
                      ></el-input>
                      <div class="price-info">
                        <span>原价：{{ scope.row.item.price }}</span>
                        <span>
                          {{
                          priceIncreasePercent(
                          scope.row.item.price,
                          scope.row.price
                          )
                          }}%
                        </span>
                      </div>
                      <template slot-scope="scope"></template>
                    </template>
                  </el-table-column>
                  <el-table-column prop="count" label="数量" width="110">
                    <template slot-scope="scope">
                      <el-input-number
                        size="mini"
                        v-model="scope.row.count"
                        :step="1"
                        :min="0"
                        @change="recalculateItemFee()"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                </el-table>
                <template v-for="(pk, index) in device.packages">
                  <p class="table-header" style="padding-left:44px">{{ pk.name }}</p>
                  <el-table
                    :key="index"
                    :data="pk.items"
                    style="width: 100%"
                    empty-text
                    :show-header="false"
                  >
                    <el-table-column width="34"></el-table-column>
                    <el-table-column prop="name" :label="pk.name"></el-table-column>
                    <el-table-column prop="part_number" label width="160"></el-table-column>
                    <el-table-column prop="price" width="100"></el-table-column>
                    <el-table-column prop="count" label width="110">
                      <template slot-scope="scope">
                        <span>{{ scope.row.count }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <el-table :data="oils" style="width: 100%" empty-text="暂无油品信息" :key="Math.random()">
                  <el-table-column width="34">
                    <template slot-scope="scope">
                      <el-radio
                        v-model="device.oilID"
                        @change="oilChange(device)"
                        :key="scope.row.item_id"
                        :label="scope.row.item_id"
                      ></el-radio>
                    </template>
                  </el-table-column>
                  <el-table-column prop="item.name" label="油品"></el-table-column>
                  <el-table-column prop="item.part_number" label width="120"></el-table-column>
                  <el-table-column label="价格(￥)" width="160">
                    <template slot-scope="scope">
                      <el-input
                        size="mini"
                        class="font-14"
                        v-model="scope.row.price"
                        @change="recalculateItemFee()"
                        :disabled="device.oilID != scope.row.item_id"
                      ></el-input>
                      <div class="price-info" v-if="device.oilID == scope.row.item_id">
                        <span>原价：{{ scope.row.item.price }}</span>
                        <span>
                          {{
                          priceIncreasePercent(
                          scope.row.item.price,
                          scope.row.price
                          )
                          }}%
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label width="110">
                    <template slot-scope="scope" v-if="scope.row.item_id == device.oilID">
                      <el-input-number
                        size="mini"
                        v-model="device.oilCount"
                        :step="1"
                        :min="0"
                        @change="recalculateItemFee()"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                </el-table>
              </li>
            </ul>
            <div class="clearfix mt-10">
              <div style="margin-right:120px;float:right">
                <label class="text-info-12">整体调价</label>
                <el-input-number
                  style="width:40px"
                  :step="1"
                  size="mini"
                  v-model="deviceIncrease"
                  :step-strictly="true"
                ></el-input-number>%
              </div>
            </div>
          </template>
          <div class="text-info-12 mt-20" v-else>设备保养报价，请点击“+ 添加保养设备”进行报价</div>
        </div> -->
        <template>
          <!-- <div class="panel mt-20">
            <div class="header flex-row-between">
              <h2>成本</h2>
            </div>
            <el-form
              class="info-form"
              label-width="120px"
              label-position="left"
            >
              <el-form-item>
                <template slot="label">
                  <span>默认成本</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="根据预设的产品成本价计算"
                    placement="right"
                  >
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </template>
                <label for>{{ math.show(defaultCost) }}</label>
              </el-form-item>
              <el-form-item label="实际成本">
                <el-input
                  size="small"
                  style="width: 200px"
                  v-model="quotation.order_info.item_cost"
                  @change="recalculateProfit"
                  placeholder
                ></el-input>
              </el-form-item>
              <el-form-item label="预计安装成本">
                <el-input
                  size="small"
                  style="width: 200px"
                  v-model="quotation.order_info.install_cost"
                  @change="recalculateProfit"
                  placeholder
                ></el-input>
              </el-form-item>
              <el-form-item label="预计其他成本">
                <el-input
                  size="small"
                  style="width: 200px"
                  v-model="quotation.order_info.other_cost"
                  @change="recalculateProfit"
                  placeholder
                ></el-input>
              </el-form-item>
            </el-form>
          </div> -->
          <div class="panel mt-20" style="height: 97%">
            <div class="header">
              <h2>结算</h2>
            </div>
            <ul class="fee-list">
              <li>
                <div class="title">小计</div>
                <div class="symbol"></div>
                <div class="amount">
                  <span class="mr-10">{{ math.show(displayFee.item) }}</span>
                </div>
              </li>
              <li>
                <div class="title">税费（13%）</div>
                <div class="symbol">+</div>
                <div class="amount">
                  <span class="mr-10">{{ math.show(displayFee.tax) }}</span>
                </div>
              </li>
              <li>
                <div class="title">杂项</div>
                <div class="symbol">+</div>
                <div class="amount">
                  <el-input
                    size="small"
                    v-model="quotation.order_info.labor_fee"
                    @change="recalculateItemFee()"
                    class="t-a-r"
                    placeholder
                  ></el-input>
                </div>
              </li>
              <li>
                <div class="title">
                  <span>折扣金额（含税）</span>
                </div>
                <div class="symbol">-</div>
                <div class="amount">
                  <!-- {{ math.show(displayFee.discount_value) }} -->
                  <el-input
                    size="small"
                    v-model="quotation.order_info.discount_value"
                    placeholder
                    class="t-a-r"
                    @change="changedDiscountValue"
                  ></el-input>
                </div>
              </li>
              <!-- <li class="fee-list-ex">
                <div class="title"></div>
                <div class="amount">
                  <span class="text-info-12 mr-10"
                    >约{{ displayFee.discount.toFixed(2) }}%</span
                  >
                </div>
              </li> -->
              <li>
                <div class="title">最终折扣</div>
                <div class="symbol"></div>
                <div class="amount">
                  <span class="mr-10"
                    >{{ displayFee.discount.toFixed(2) }}%</span
                  >
                </div>
              </li>
              <li>
                <div class="title">合计</div>
                <div class="amount">{{ math.show(displayFee.total) }}</div>
              </li>
            </ul>
            <!-- <div class="estimate-profit">
              <div class>
                <i class="el-icon-money"></i>
                预计利润：
                <span v-html="profit"></span>
              </div>
              <template v-if="orderInfoFlow">
                <div>
                  <i class="el-icon-coin"></i>
                  利润率：{{ profit_rate }}%
                </div>
                <div v-if="orderInfoFlow.flow.id > 0">
                  审批流程：{{ orderInfoFlow.flow.name }}
                  <span class="text-gray">
                    （
                    <span v-html="orderInfoFlow.users"></span>）
                  </span>
                </div>
              </template>
            </div> -->
          </div>
        </template>
      </el-col>
      <el-col :span="16" style="flex-grow: 1; padding-top: 20px">
        <div class="panel" style="height: 100%">
          <div class="header">
            <h2>其他信息</h2>
          </div>
          <el-form class="info-form" label-width="100px" label-position="left">
            <!-- <el-form-item label="备注">
              <el-input
                v-model="quotation.order_info.remark"
                size="small"
              ></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="报价期">
              <el-date-picker
                style="width:100%"
                v-model="quotation.order_info.expire_date"
                type="date"
                size="small"
                placeholder="选择日期"
                :picker-options="datePickerOptions"
              ></el-date-picker>
            </el-form-item>-->
            <!-- <el-form-item label="到货期">
              <el-date-picker
                style="width: 100%"
                v-model="quotation.order_info.delivery_date"
                type="date"
                size="small"
                placeholder="选择日期"
                :picker-options="datePickerOptions"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item label="收货地址">
              <el-input
                v-model="quotation.order_info.shipping_address"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人">
              <el-input
                v-model="quotation.order_info.consignee_name"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人电话">
              <el-input
                v-model="quotation.order_info.consignee_mobile"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="发票信息">
              <el-select
                style="width: 100%"
                size="small"
                v-model="quotation.order_info.invoice_id"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in invoices"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收票地址">
              <el-input
                v-model="quotation.order_info.invoice_shipping_address"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收票人">
              <el-input
                v-model="quotation.order_info.invoice_consignee_name"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收票人电话">
              <el-input
                v-model="quotation.order_info.invoice_consignee_mobile"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="收票人邮箱">
              <el-input
                v-model="quotation.order_info.invoice_consignee_email"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="补充信息" class="ql-editor-item">
              <!-- <quill-editor
                class="editor"
                v-model="quotation.order_info.remark"
                ref="remarkEditor"
                :options="editorOption"
              > -->
              <!-- <rich-editor
                class="rich-editor"
                v-model="quotation.order_info.remark"
              ></rich-editor> -->
              <el-input
                type="textarea"
                v-model="quotation.order_info.remark"
                :rows="2"
              ></el-input>
              <!-- <div class="mt-10 flex-row-between">
                <el-button type="text" size="small" @click="selectRemarkTemp()"
                  >引用模板</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  :disabled="quotation.order_info.remark.length == 0"
                  @click="saveRemarkTemp()"
                  >保存为模板</el-button
                >
              </div> -->
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <div class="panel mt-20">
      <el-checkbox
        style="color: #888; margin-right: 10px"
        v-if="quotation.id > 0 && !orderMode"
        v-model="save_as_new_version"
        :disabled="selectedVersion > 0"
        >保存为新版本</el-checkbox
      >
      <el-button
        icon="el-icon-check"
        size="medium"
        type="primary"
        @click="postQuotation"
        :loading="submiting"
        >保存
      </el-button>
      <el-button
        icon="el-icon-view"
        size="medium"
        type="primary"
        plain
        @click="previewQuotation()"
        >预览</el-button
      >
    </div>
    <device-selector
      :show.sync="deviceSelectorVisible"
      :devices="devices"
      :selection="quotation.order_info.devices"
      :customerID="customerID"
      @selected="doneSelectedDevices"
    ></device-selector>
    <item-selector
      :show.sync="itemSelectorVisible"
      :selection="itemSelection"
      @selected="doneSelectedItems"
      :deviceid="optionDeviceId"
    >
    </item-selector>
    <item-selector
      :show.sync="productSelectorVisible"
      :selection="quotation.order_info.products"
      :multiple="true"
      @selected="doneSelectedProducts"
    ></item-selector>
    <quotation-preview
      :show.sync="quotationPreviewVisibile"
      :quotation="quotationPreview"
      :fee="displayFee"
      :editPreview="true"
    ></quotation-preview>
    <customer-contact-former
      :model="customerContactForm"
      :show.sync="createCustomerContactFormVisible"
      @created="createdCustomerContact"
    ></customer-contact-former>
    <remark-temp-former
      :show.sync="remarkTempFormerVisible"
      :content="quotation.order_info.remark"
    >
    </remark-temp-former>
    <remark-temp-selector
      :show.sync="remarkTempSelectorVisible"
      @selected="selectedRemarkTemp"
    ></remark-temp-selector>

    <DeviceWikiDrawer
      :model="wikiModel"
      :show.sync="wikiVisible"
    ></DeviceWikiDrawer>
  </div>
</template>

<script>
import { getStore } from '@/config/storage'
import Vue from 'vue'
import visitMap from '@/config/visit.json'
import schedule_setting from '@/config/schedule_setting.json'

import {
  customerDetail,
  customerDeviceList,
  customerInvoiceList,
  createQuotaion,
  customerContactList,
  quotationDetail,
  itemList,
  itemDetail,
  updateQuotaion,
  createCustomerOrder,
  customerOrderDetail,
  updateCustomerOrder,
  itemCostPrice,
  orderInfoFlow,
  quotationVersionDetail,
} from '../../service/getData'
import DeviceSelector from '@/components/quotation_device_selector'
import ItemSelector from '@/components/commodity_selector'
import QuotationPreview from '@/components/quotation_preview'
import CustomerContactFormer from '@/components/customer_contact'
import RemarkTempFormer from '@/components/remark_temp_former'
import RemarkTempSelector from '@/components/remark_temp_selector'
import ServiceQuestSelect from '@/components/select/service_quest_select'
import CustomerDeviceSelect from '@/components/select/customer_device_select'

import { DeviceWorkConditions, DeviceRunTimes } from '@/config/global'
import { numberMul, priceIncreasePercent, CustomerAddress } from '@/util/index'
import RichEditor from '@/components/rich-editor'
import { clone } from '@/util'
import { re } from 'semver'
import store from '@/store/store'
import { CodeToText } from '@/util/area_tool'
import math from '@/util/math'
import {
  urlPerfix,
  host,
  thumbnailImagePath,
  originImagePath,
} from '@/config/env'

import {
  DisplayOrderFee,
  CalculateProfit,
  ItemCostPrices,
  AutoOrderInfoFlow,
} from '@/util/order_calculate'

import DeviceWikiDrawer from './DeviceWikiDrawer.vue'

export default {
  components: {
    CustomerDeviceSelect,
    DeviceSelector,
    ItemSelector,
    QuotationPreview,
    CustomerContactFormer,
    RemarkTempFormer,
    RemarkTempSelector,
    RichEditor,
    ServiceQuestSelect,
    DeviceWikiDrawer,
  },
  data() {
    return {
      optionDeviceId: 0,
      selectedAll: false,
      selectedIndexs: [],
      customerID: parseInt(this.$route.query.customer),
      quotationID: parseInt(this.$route.query.quotation),
      orderID: parseInt(this.$route.query.order),
      orderMode: false,
      deviceSelectorVisible: false,
      itemSelectorVisible: false,
      quotationPreviewVisibile: false,
      productSelectorVisible: false,
      productSelection: [],
      discount: 0,
      labor: 0,
      numberMul: numberMul,
      currentDate: '',
      quotations: [],
      runtimes: DeviceRunTimes,
      conditions: DeviceWorkConditions,
      itemSelection: [],
      itemSelectionIndex: -1,
      CodeToText,
      math,
      CustomerAddress,
      priceIncreasePercent,
      productIncrease: 0,
      deviceIncrease: 0,
      submiting: false,
      remarkTempFormerVisible: false,
      remarkTempSelectorVisible: false,
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now()
        },
      },
      userInfo: store.getters.userInfo,
      oils: [],
      oilKeyword: 'VACUUM FLUID',
      devices: [],
      invoices: [],
      contacts: [],
      contactTips: [],
      quotationPreview: null,
      save_as_new_version: false,
      quotation: {
        customer: {},
        user: store.getters.userInfo,
        number: '',
        customer_id: null,
        type: 0,
        order_info: {
          remark: '',
          delivery_date: null,
          shipping_address: '',
          consignee_name: null,
          consignee_mobile: null,
          invoice_shipping_address: '',
          invoice_consignee_name: null,
          invoice_consignee_mobile: null,
          invoice_consignee_email: null,
          invoice_id: null,
          invoice: {},
          labor_fee: 0,
          total_fee: 0,
          discount: 0,
          discount_value: 0,
          amount: 0,
          itemFee: 0,
          devices: [],
          item_cost: 0,
          install_cost: 0,
          other_cost: 0,
          products: [],
          project_name: '',
          customer_contact_id: null,
          business_chance_number: '',
          customer_contact: {},
          type: null,
          business_opportunity_type: null,
          install_customer_id: null,
        },
      },
      defaultCost: 0,
      profit: '',
      profit_rate: 0,
      totalFee: 0,
      checkedProducts: [],
      itemCostPrices: [],
      orderInfoFlow: null,
      displayFee: {
        item: 0,
        tax: 0,
        labor: 0,
        discount: 0,
        discount_value: 0,
        total: 0,
      },
      createCustomerContactFormVisible: false,
      customerContactForm: {
        name: '',
        duty: '',
        mobile: '',
        email: '',
      },
      versions: [],
      selectedVersion: 0,
      orderInfoRules: {
        type: [
          { required: true, message: '请选择报价类型', trigger: 'change' },
        ],
        customer_contact_id: [
          { required: true, message: '请选择选择保价联系人', trigger: 'blur' },
          { type: 'number', message: '请选择选择保价联系人' },
        ],
        // serial_number: [
        //   { required: true, message: '请输入设备序列号', trigger: 'blur' },
        //   { type: 'string', message: '请输入设备序列号' }
        // ],
        project_name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
      },
      wikiModel: {},
      wikiVisible: false,
    }
  },
  computed: {},
  watch: {
    'quotation.order_info.customer_contact_id': function () {
      for (let index = 0; index < this.contacts.length; index++) {
        const element = this.contacts[index]
        if (element.id == this.quotation.order_info.customer_contact_id) {
          this.quotation.order_info.customer_contact = element
          break
        }
      }

      this.quotation.order_info.consignee_name =
        this.quotation.order_info.customer_contact.name
      this.quotation.order_info.consignee_mobile =
        this.quotation.order_info.customer_contact.mobile
    },
    'quotation.order_info.invoice_id': function () {
      for (let index = 0; index < this.invoices.length; index++) {
        const element = this.invoices[index]
        if (element.id == this.quotation.order_info.invoice_id) {
          this.quotation.order_info.invoice = element
          this.quotation.order_info.invoice_shipping_address =
            element.consignee_address
          this.quotation.order_info.invoice_consignee_name =
            element.consignee_name
          this.quotation.order_info.invoice_consignee_mobile =
            element.consignee_mobile
          this.quotation.order_info.invoice_consignee_email =
            element.consignee_email
          return
        }
      }
    },
    selectedVersion: function () {
      this.save_as_new_version = this.selectedVersion > 0
      let orderInfo = this.versions[this.selectedVersion].orderInfo
      if (!orderInfo) {
        this.requestQuotationVersion()
        return
      }
      this.quotation.order_info = this.versions[this.selectedVersion].orderInfo
      this.formatOrderInfo()
    },
    productIncrease: function () {
      const percent = math.add(
        math.divide(parseInt(this.productIncrease), 100),
        1
      )
      this.quotation.order_info.products.map((item) => {
        const price = math.multiply(item.item.price, percent)
        item.price = math.toFixed(price)
      })

      this.recalculateItemFee()
    },
    deviceIncrease: function () {
      const percent = math.add(
        math.divide(parseInt(this.deviceIncrease), 100),
        1
      )
      this.quotation.order_info.devices.map((device) => {
        device.items.map((item) => {
          const price = math.multiply(item.item.price, percent)
          item.price = math.toFixed(price)
        })

        this.oils.map((item) => {
          if (item.item_id == device.oilID) {
            const price = math.multiply(item.item.price, percent)
            item.price = math.toFixed(price)
          }
        })
      })
      this.recalculateItemFee()
    },
  },
  mounted() {},
  created() {
    this.orderMode = this.$route.path.indexOf('order_editor') > 0
    this.requestOilItemList()

    if (this.quotationID > 0 || this.orderID > 0) {
      this.requestOrderInfo()
    } else {
      this.requestCustomer()
      this.requestCustomerDevies()
      this.requestCustomerInvoices()
      this.requestCustomerContactList()
    }
  },

  methods: {
    openDeviceWiki(deivce) {
      this.wikiModel = deivce
      this.wikiVisible = true
    },
    checkInstallCustomerId(rule, value, callback) {
      const devices = this.quotation.order_info.devices
      if (!devices) {
        return callback()
      }
      var hasServiceOrOffCommodiy = false
      for (let index = 0; index < devices.length; index++) {
        const device = devices[index]
        hasServiceOrOffCommodiy =
          device.items.filter(
            (item) => item.item.type == 2 || item.item.status == 0
          ).length > 0
        if (hasServiceOrOffCommodiy) {
          break
        }
      }

      if (this.quotation.customer != 6 && hasServiceOrOffCommodiy && !value) {
        return callback(
          new Error(
            '报价对象为中间商且商品包含服务或非上架商品时，最终用户为必选项'
          )
        )
      } else {
        callback()
      }
    },
    handleSelectedAllChange(val) {
      if (val) {
        this.$refs.itemTable.toggleAllSelection()
      } else {
        this.$refs.itemTable.clearSelection()
      }
    },
    handleSelectionChange(items) {
      this.selectedAll =
        items.length == this.quotation.order_info.products.length &&
        this.quotation.order_info.products.length > 0

      this.selectedIndexs = items.map((item) => {
        return this.quotation.order_info.products.indexOf(item)
      })
    },
    batchRemove() {
      if (this.selectedIndexs.length == 0) {
        this.$alert('请至少选择一件产品')
        return
      }

      let _this = this
      this.$confirm('确认移除选中产品嘛?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          _this.quotation.order_info.products =
            _this.quotation.order_info.products.filter(
              (item, index) => _this.selectedIndexs.indexOf(index) == -1
            )
          _this.recalculateItemFee()
          this.selectedAll = false
          this.selectedIndexs = []
        })
        .catch(() => {})
    },
    async requestOrderInfo() {
      var res
      if (this.orderMode) {
        res = await customerOrderDetail(this.orderID)
      } else {
        res = await quotationDetail(this.quotationID)
      }

      this.quotation = res.data
      if (!this.orderMode) {
        // 提取版本列表
        this.versions = res.data.versions.map((v, i) => {
          return {
            title: '历史版本 v' + (i + 1),
            version: v,
          }
        })
        this.versions.unshift({
          title: '当前版本',
          orderInfo: this.quotation.order_info,
        })
        delete this.quotation.versions
      }
      this.customerID = this.quotation.customer_id
      this.formatOrderInfo()

      this.requestCustomerDevies()
      this.requestCustomerInvoices()
      this.requestCustomerContactList()
    },
    // OrderInfo数据格式化
    formatOrderInfo() {
      this.quotation.order_info.customer_contact_id =
        this.quotation.order_info.customer_contact_id > 0
          ? this.quotation.order_info.customer_contact_id
          : null
      this.quotation.order_info.invoice_id =
        this.quotation.order_info.invoice_id > 0
          ? this.quotation.order_info.invoice_id
          : null
      this.quotation.order_info.devices = this.quotation.order_info.devices.map(
        (device) => {
          let oilID = 0
          let oilCount = 0
          let qitems = []
          for (let index = 0; index < device.items.length; index++) {
            const element = device.items[index]
            delete element.id
            delete element.quotation_device_id
            if (element.item.name.indexOf(this.oilKeyword) != -1) {
              oilID = element.item_id
              oilCount = element.count
            } else {
              element.checked = true
              qitems.push(element)
            }
          }
          device.items = qitems
          device.oilID = oilID
          device.oilCount = oilCount
          delete device.id
          return device
        }
      )

      this.quotation.order_info.products.map((p) => {
        p.checked = true
      })

      this.recalculateItemFee()
    },
    async requestCustomer() {
      let res = await customerDetail(this.customerID)
      this.quotation.customer = res.data

      this.quotation.order_info.invoice_shipping_address =
        res.data.invoice_shipping_address
      this.quotation.order_info.invoice_consignee_name =
        res.data.invoice_consignee_name
      this.quotation.order_info.invoice_consignee_mobile =
        res.data.invoice_consignee_mobile
      this.quotation.order_info.invoice_consignee_email =
        res.data.invoice_consignee_email

      this.quotation.order_info.shipping_address = CustomerAddress(
        this.quotation.customer
      )
    },

    async requestCustomerDevies() {
      let res = await customerDeviceList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.devices = res.data.list.map((item) => {
        item.oilID = 0
        item.oilCount = 1
        return item
      })

      // if (!this.quotationID) {
      //   this.openDeviceSelector()
      // }
    },
    async requestCustomerInvoices() {
      let res = await customerInvoiceList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.invoices = res.data.list
    },
    async requestCustomerContactList() {
      let res = await customerContactList({
        customer_id: this.customerID,
      })
      if (res.code == 0) {
        this.contacts = res.data.list
        this.contactTips = this.contacts.map((item) => {
          return { value: item.name }
        })
      }
    },
    async requestOilItemList() {
      let res = await itemList({
        page: 0,
        size: 10,
        dealer_id: 0,
        query: this.oilKeyword,
      })
      if (res.code == 0) {
        this.oils = res.data.list.map((item) => {
          let qitem = {}
          qitem.item = item
          qitem.count = 1
          qitem.item_id = item.id
          qitem.price = item.price
          return qitem
        })
      }

      if (this.quotation.id > 0) {
        this.recalculateItemFee()
      }
    },
    postQuotation() {
      this.$refs.orderInfoForm.validate(async (valid) => {
        if (valid) {
          if (
            this.quotation.order_info.type == 2 &&
            this.quotation.order_info.devices.filter(
              (item) => !item.customer_device_id
            ).length > 0
          ) {
            this.$alert(
              '服务类型报价下产品清单中设备不能为空，请选择设备或删除空设备！'
            )
            return
          }
          this.submitQuotation()
        } else {
          // window.scrollTo(0, 0)
        }
      })
    },
    async submitQuotation() {
      if (
        this.quotation.order_info.devices.length == 0 &&
        this.quotation.order_info.products.length == 0
      ) {
        return
      }
      let data = clone(this.quotation)
      data.customer_id = this.customerID

      let orderInfo = data.order_info
      orderInfo.devices = orderInfo.devices.map((d) => {
        let device = {}
        device.customer_device_id = d.customer_device_id || d.id
        device.item_category_id = d.item_category_id
        device.working_condition = d.working_condition
        device.running_time = d.running_time
        device.device_id = d.device_id

        device.items = d.items
          .filter((item) => {
            return item.checked && item.count > 0
          })
          .map((item) => {
            item.price = parseFloat(item.price)
            return item
          })

        var oil
        for (let index = 0; index < this.oils.length; index++) {
          const element = this.oils[index]
          if (d.oilID == element.item_id) {
            oil = element
          }
        }
        if (oil) {
          oil.count = d.oilCount
          oil.price = parseFloat(oil.price)
          device.items.push(oil)
        }
        return device
      })

      orderInfo.products = orderInfo.products
        .filter((product) => {
          return product.checked && product.count > 0
        })
        .map((item) => {
          item.price = parseFloat(item.price)
          return item
        })

      orderInfo.labor_fee = parseFloat(orderInfo.labor_fee) || 0
      orderInfo.discount = parseFloat(orderInfo.discount) || 0
      orderInfo.discount_value = parseFloat(orderInfo.discount_value) || 0
      orderInfo.item_cost = parseFloat(orderInfo.item_cost) || 0
      orderInfo.install_cost = parseFloat(orderInfo.install_cost) || 0
      orderInfo.other_cost = parseFloat(orderInfo.other_cost) || 0
      data.order_info = orderInfo

      delete data.order_info.customer_contact
      delete data.order_info.invoice
      delete data.user

      if (this.quotation.id > 0 && this.quotation.status > 0) {
        let that = this

        if (that.orderMode) {
          that.submiting = true
          updateCustomerOrder(data).then((res) => {
            if (res.code == 0) {
              that.$router.push(
                `/dashboard/${
                  res.data.customer_user_id ? 'customer' : 'dealer'
                }/orders/` + res.data.id
              )
            }
            that.submiting = false
          })
        } else {
          this.$confirm('修改报价单后需重新提交审核，是否提交?', '提示', {
            confirmButtonText: '提交',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            that.submiting = true
            data.new_version = that.save_as_new_version
            updateQuotaion(data).then((res) => {
              if (res.code == 0) {
                that.$router.push('/dashboard/quotations/' + res.data.id)
              }
              that.submiting = false
            })
          })
        }
      } else if (this.quotation.id > 0 && this.quotation.status == 0) {
        let res = await updateQuotaion(data)
        if (res.code == 0) {
          this.$router.push('/dashboard/quotations/' + res.data.id)
        }
        this.submiting = false
      } else {
        this.submiting = true
        var res
        if (this.orderMode) {
          res = await createCustomerOrder(data)
        } else {
          res = await createQuotaion(data)
        }
        if (res.code == 0) {
          if (this.orderMode) {
            this.$router.push(
              `/dashboard/${
                res.data.customer_user_id ? 'customer' : 'dealer'
              }/orders/` + res.data.id
            )
          } else {
            this.$router.push('/dashboard/quotations/' + res.data.id)
          }
        }
        this.submiting = false
      }
    },
    reloadDeviceScheme(device, index) {
      let loadedDevice = this.loadDeviceScheme(device)
      this.devices.splice(index, 1, loadedDevice)
    },
    recalculateItemFee(index) {
      if (index >= 0) {
        let p = this.quotation.order_info.products[index]
        p.price = parseFloat(p.price)
      }
      this.displayFee = DisplayOrderFee(this.quotation.order_info)

      // let that = this
      // ItemCostPrices(this.quotation.order_info, function (cost) {
      //   that.defaultCost = cost
      //   that.quotation.order_info.item_cost = cost.toFixed(2)
      //   that.recalculateProfit()
      // })

      // AutoOrderInfoFlow(
      //   this.quotation.order_info,
      //   this.oils,
      //   function (orderInfoFlow) {
      //     that.orderInfoFlow = orderInfoFlow
      //   }
      // )
    },
    recalculateProfit() {
      let that = this
      CalculateProfit(this.quotation.order_info, function (profit, profitRate) {
        that.profit = profit
        that.profit_rate = profitRate
      })
    },
    loadDeviceScheme(device) {
      let categories = [
        'Consumables',
        'Valves',
        'Overhaul Element',
        'Overhaul Motor',
        'VACUUM FLUID BASIC - 20L',
        'VACUUM FLUID ULTRA - 20L',
      ]

      let condtion = device.working_condition
      let runtime = device.running_time
      var visits = []
      categories.map((cate) => {
        let key = cate + '-' + condtion
        let scheme = schedule_setting[key]
        if (scheme) {
          let setting = scheme['' + runtime]
          if (setting) {
            visits.push(setting)
          }
        }
      })

      // 无方案排除
      visits = visits.filter((item) => {
        return item.length > 0
      })
      // 去重
      visits = Array.from(new Set(visits))

      var plist = []
      var oils = []
      var packages = []
      visits.map((visit) => {
        var ps = visitMap[visit]
        ps = ps.filter((p) => {
          if (p.model === '*') {
            return true
          }

          let reg = new RegExp(p.model)
          let match = reg.test(device.item_category.name)
          return match
        })

        plist = plist.concat(ps)
      })
      device.part_numbers = plist.map((item) => {
        return item.part_number
      })
      device.customer_device_id = device.id
      device.items = []
      device.packages = []
      this.requestDeviceItems(device)
      return device
    },
    oilChange(device) {
      device.oilCount = 1
      this.recalculateItemFee()
    },
    toggelChecked(row) {
      row.checked = !row.checked
      this.recalculateItemFee()
    },
    handleProductSelectionChange(val) {
      this.selectedProducts = val.map((item) => {
        item.count = 1
        return item
      })
    },
    openDeviceSelector() {
      // this.deviceSelectorVisible = true
      this.quotation.order_info.devices.push({
        customer_device_id: '',
        items: [],
      })
    },
    doneSelectedDevices(sel) {
      let newDevices = sel.map((device) => {
        return this.loadDeviceScheme(device)
      })
      this.quotation.order_info.devices =
        this.quotation.order_info.devices.concat(newDevices)
      this.recalculateItemFee()
    },
    contactQuerySearch(query, cb) {
      cb(this.contactTips)
    },
    handleContactSelect(item) {},
    async requestDeviceItems(device) {
      if (device.part_numbers.length == 0) {
        return
      }

      let data = {
        dealer_id: 0,
        page: 0,
        size: 1000,
        part_numbers: device.part_numbers.join(','),
      }
      let res = await itemList(data)
      device.items = res.data.list.map((item) => {
        let qitem = {}
        qitem.item_id = item.id
        qitem.checked = true
        qitem.count = 1
        qitem.price = item.price
        qitem.customer_device_id = device.customer_device_id
        if (item.package == 1) {
          this.requestDeviceItemPackage(device, item)
        }
        qitem.item = item
        return qitem
      })

      let index = this.quotation.order_info.devices.indexOf(device)
      if (index >= 0) {
        this.quotation.order_info.devices.splice(index, 1, device)
        this.recalculateItemFee()
      }
    },
    async requestDeviceItemPackage(device, item) {
      let res = await itemDetail(item.id)
      let pk = {
        name: item.name + '明细',
        items: res.data.items,
      }
      device.packages.push(pk)

      let index = this.quotation.order_info.devices.indexOf(device)
      if (index >= 0) {
        this.quotation.order_info.devices.splice(index, 1, device)
      }
    },
    openItemSelector(device, index) {
      this.optionDeviceId = device.customer_device_id || 0
      this.itemSelectorVisible = true
      this.itemSelection = device.items.filter((i) => {
        return i.checked
      })
      this.itemSelectionIndex = index
    },
    doneSelectedItems(products) {
      // let device = this.quotation.order_info.devices[this.itemSelectionIndex]
      // let newItems = sel.map((item) => {
      //   let qitem = {}
      //   qitem.item_id = item.id
      //   qitem.checked = true
      //   qitem.count = 1
      //   qitem.price = item.price
      //   qitem.original_price = item.price
      //   if (item.package == 1) {
      //     this.requestDeviceItemPackage(device, item)
      //   }
      //   qitem.item = item
      //   return qitem
      // })
      // device.items = device.items.concat(newItems)
      // this.recalculateItemFee()

      const percent = math.add(
        math.divide(parseInt(this.deviceIncrease), 100),
        1
      )

      let pitems = products.map((p) => {
        let qitem = {}
        qitem.price = p.price
        qitem.original_price = p.price
        if (this.deviceIncrease) {
          const price = math.multiply(p.price, percent)
          qitem.price = math.toFixed(price)
        }
        qitem.count = 1
        qitem.checked = true
        qitem.item_id = p.id
        qitem.item = p
        return qitem
      })

      let device = this.quotation.order_info.devices[this.itemSelectionIndex]
      this.quotation.order_info.devices[this.itemSelectionIndex].items =
        device.items.concat(pitems)
      this.recalculateItemFee()
    },
    doneSelectedProducts(products) {
      const percent = math.add(
        math.divide(parseInt(this.productIncrease), 100),
        1
      )

      let pitems = products.map((p) => {
        let qitem = {}
        qitem.price = p.price
        qitem.original_price = p.price
        if (this.productIncrease) {
          const price = math.multiply(p.price, percent)
          qitem.price = math.toFixed(price)
        }
        qitem.count = 1
        qitem.checked = true
        qitem.item_id = p.id
        qitem.item = p
        return qitem
      })
      let oproducts = this.quotation.order_info.products
      this.quotation.order_info.products = oproducts.concat(pitems)
      this.recalculateItemFee()
    },
    removeDevice(index) {
      this.quotation.order_info.devices.splice(index, 1)
      this.recalculateItemFee()
    },
    removeDeviceItem(index, itemIndex) {
      this.quotation.order_info.devices[index].items.splice(itemIndex, 1)
      this.recalculateItemFee()
    },
    changedDiscount() {
      this.recalculateItemFee()
    },
    changedDiscountValue() {
      this.recalculateItemFee()
    },
    previewQuotation() {
      this.quotationPreview = clone(this.quotation)
      this.quotation.order_info.devices.map((device) => {
        var oil
        for (let index = 0; index < this.oils.length; index++) {
          const element = this.oils[index]
          if (d.oilID == element.item_id) {
            oil = element
          }
        }
        if (oil) {
          oil.count = d.oilCount
          device.items.push(oil)
        }
      })
      this.quotationPreviewVisibile = true
    },
    startCustomerContactFormer() {
      this.customerContactForm = {
        customer_id: this.customerID,
        name: '',
        duty: '',
        mobile: '',
        email: '',
      }
      this.createCustomerContactFormVisible = true
    },
    createdCustomerContact(contact) {
      this.contacts.unshift(contact)
      this.quotation.order_info.customer_contact_id = contact.id
    },
    removeProducts(index) {
      this.$confirm('是否移除此产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.quotation.order_info.products.splice(index, 1)
        this.$refs.itemTable.clearSelection()
        this.recalculateItemFee()
      })
    },
    saveRemarkTemp() {
      this.remarkTempFormerVisible = true
    },
    selectRemarkTemp() {
      if (this.quotation.order_info.remark.length > 0) {
        this.$confirm(
          '引用模板将会覆盖已输入内容，是否确定引用新模板',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          this.remarkTempSelectorVisible = true
        })
      } else {
        this.remarkTempSelectorVisible = true
      }
    },
    selectedRemarkTemp(temp) {
      if (temp && temp.content) {
        this.quotation.order_info.remark = temp.content
      }
    },
    async requestQuotationVersion() {
      let index = this.selectedVersion
      let vid = this.versions[index].version.id
      let res = await quotationVersionDetail({
        id: this.quotation.id,
        vid: vid,
      })
      if (res.code == 0) {
        this.versions[index].orderInfo = res.data
        if (index == this.selectedVersion) {
          this.quotation.order_info = res.data
          this.formatOrderInfo()
        }
      }
    },
  },
}
</script>

<style scoped>
.q-info p {
  font-size: 14px;
  color: #333;
  margin: 0 0 10px 0;
}

.q-info p span {
  margin-left: 2em;
}

.q-info {
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.device-header {
  background-color: #fff7ea;
  border: 1px solid #e9d9c1;
  padding: 10px;
  margin-bottom: 10px;
  color: #3e4b5b;
}

h3 {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.q-products {
  background-color: #dae1f2;
}

.q-products .title {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.total {
  margin-top: 10px;
  overflow: hidden;
}

.total .row {
  width: 100%;
  clear: both;
}

.total .row span {
  width: 120px;
  padding: 12px 10px;
  box-sizing: border-box;
}

.total .row span.title {
  width: 110px;
  color: #909399;
}

.device-select {
  text-align: left;
}

.device-select label {
  color: #3e4b5b;
  margin-left: 10px;
  margin-right: 3px;
  font-size: 12px;
}

.devices li {
  margin-bottom: 20px;
}

.devices li:first-child {
  margin-top: 10px;
}

.info-form .el-form-item {
  margin-top: 10px;
  margin-bottom: 0;
}

.del-device {
  border: 0 none;
  background: #fff;
}

.number-info .title {
  display: block;
  color: #adb5bd;
  line-height: 1.3;
}

.number-info .content {
  font-size: 1.5rem;
  font-weight: 500;
}

.el-table__body .el-input-number--mini {
  width: 100px !important;
}

.customer-info {
  background-color: #fff6d7;
  position: relative;
}

.customer-info li {
  display: flex;
  line-height: 24px;
}

.customer-link {
  position: absolute;
  right: 20px;
  top: 20px;
}

/deep/.rich-editor .ql-editor {
  min-height: 240px;
}

.quotation-customer li {
  border-top: 0 none;
}

.fee-list-ex {
  border: 0 none;
  padding-top: 0;
  margin-top: 4px;
}

.order-form {
  display: flex;
  flex-wrap: wrap;
}

.order-form .el-form-item {
  width: 330px;
  margin-right: 20px;
}

/deep/.order-form .el-form-item__label {
  padding: 0;
  line-height: 2;
  color: #adb5bd;
  font-size: 0.8rem;
}
</style>
